var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeleconsulta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 154,
    viewBox: "0 0 128 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "il-teleconsulta"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1459_3443",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 128,
    height: 154
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    y: 0.199951,
    width: 128,
    height: 153.6,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1459_3443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ilustra"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.6,
    y: 141,
    width: 58.88,
    height: 66.56,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M89.5713 69.3201L32 68.7929C32.1448 60.5 34.0957 52.3565 38.3604 45.0693C41.1612 40.2834 41.1007 35.0748 40.4257 30.6867C39.3841 23.9149 41.8063 16.9864 47.1887 12.6757C51.302 9.37573 56.4934 7.677 61.7851 7.89952L62.903 7.94558C70.3025 8.24971 77.0373 12.2557 80.7772 18.5774C82.6478 21.8985 83.4022 25.7218 82.9313 29.4948C82.5664 33.0449 83.4395 36.6311 85.4819 40.2514C89.0056 48.2012 89.7686 58.374 89.5713 69.3201Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 61.44,
    cy: 34.76,
    r: 15.36,
    fill: "#D89379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M74.24 62.9201L49.92 61.4268C52.3034 55.7165 53.2555 50.2176 52.3043 45.0001H70.4251C70.384 49.0062 72.2938 55.9359 74.24 62.9201Z",
    fill: "#D89379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M90.88 152.459L35.84 156.36L41.4913 59.568L51.0743 56.886L61.8856 59.324L72.6969 53.9601L79.577 56.3986L90.88 152.459Z",
    fill: "#8FD16A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M44.4676 221.64L7.67999 213.135C18.6189 176.472 38.3258 92.5984 31.9646 62.7086L51.2 53.9601L44.4676 221.64Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M26.72 116.68L12.8 107.913L24.6713 72.6311C25.9953 68.9904 28.5314 65.9337 31.8409 63.9894L35.84 61.64L33.44 97.1968L26.72 116.68Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M122.88 214.954C111.133 221.758 81.7705 225.552 68.8779 220.799C67.9292 187.599 66.0687 93.6901 72.0402 53.9601L93.4464 62.7283L91.5004 89.0328C81.2665 111.535 110.984 189.91 122.88 214.954Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M120.146 111.56L107.054 107.155L89.6 87.0892L92.5093 61.64L121.6 102.75L120.146 111.56Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M79.4494 130.329C79.8898 132.395 81.8113 133.691 83.7453 133.225L94.72 130.569L93.1338 123.08L82.159 125.736C80.2246 126.205 79.0116 128.261 79.4494 130.329H79.4494Z",
    fill: "#D89379"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2",
    cx: 62.72,
    cy: 23.2401,
    rx: 16.64,
    ry: 5.12,
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M89.6 123.08L95.84 134.6C106.336 131.673 115.432 122.444 124.16 111.56L121.76 103.88L106.88 107.72L89.6 123.08Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M85.76 98.7601H83.7486C83.7486 71.2424 77.8911 52.0657 72.1829 52.0657L71.68 50.1201C76.7992 50.1201 80.0628 58.1013 81.8992 64.7969C84.3889 73.8739 85.76 85.9356 85.76 98.7601Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M40.3421 91.0801H38.4C38.4 65.8151 44.0947 50.1201 52.48 50.1201L51.9945 52.0706C46.1944 52.0706 40.3421 64.1327 40.3421 91.0801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3",
    cx: 84.48,
    cy: 98.7601,
    r: 5.12,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M32.7111 103.88H30.72C30.72 96.8221 34.7394 91.0801 39.68 91.0801V93.0493C35.8373 93.0493 32.7111 97.908 32.7111 103.88Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M48.64 103.88H46.6489C46.6489 97.908 43.5227 93.0493 39.68 93.0493V91.0801C44.6206 91.0801 48.64 96.8222 48.64 103.88Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4",
    cx: 46.72,
    cy: 103.24,
    r: 1.92,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5",
    cx: 31.36,
    cy: 103.24,
    r: 1.92,
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M7.67999 85.9601L19.7568 88.16L47.36 128.2L32.6955 124.68L7.67999 85.9601Z",
    fill: "#8FD16A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M4.84723 84.6801C4.47407 84.6858 4.13361 84.8989 3.95894 85.236C3.78428 85.5731 3.80314 85.9807 4.00817 86.2994L29.6952 126.136C29.8386 126.359 30.06 126.517 30.3139 126.578L42.2653 129.452C42.6779 129.551 43.1075 129.38 43.3449 129.021C43.5823 128.662 43.578 128.191 43.3342 127.836L15.1314 86.8471C14.9769 86.6216 14.7411 86.4681 14.4758 86.4203L5.03988 84.6978C4.97629 84.6862 4.91183 84.6802 4.84723 84.6801Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M20.48 112.783L21.1997 120.52L32.5569 119.317C34.5588 119.105 36.0206 117.201 35.8219 115.064C35.6232 112.927 33.8393 111.367 31.8374 111.579L20.48 112.783Z",
    fill: "#D89379"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M11.52 112.508C11.5549 117.646 15.8041 121.794 21.0377 121.8H22.9372L24.32 110.487L12.8703 106.44L11.52 112.508Z",
    fill: "#FDFDFD"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeleconsulta);
export default __webpack_public_path__ + "static/media/teleconsulta.e513f397.svg";
export { ForwardRef as ReactComponent };